// extracted by mini-css-extract-plugin
module.exports = {"modal":"Contents_modal_2bom2","close":"Contents_close_1BdTI","title":"Contents_title_1FLPi","title_wrap":"Contents_title_wrap_1hld9","content":"Contents_content_1ORBp"};